import { render, staticRenderFns } from "./work-order-view-table.vue?vue&type=template&id=20f50b6b&scoped=true"
import script from "./work-order-view-table.vue?vue&type=script&lang=js"
export * from "./work-order-view-table.vue?vue&type=script&lang=js"
import style0 from "./work-order-view-table.vue?vue&type=style&index=0&id=20f50b6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f50b6b",
  null
  
)

export default component.exports